// =============================================================================
// skins.ts — Skins procedurais dos personagens (issue #24): variantes visuais
// geradas em canvas por cima dos sprites existentes. Todo personagem tem o
// "Traje Oficial" (visual padrão); alguns ganham trajes alternativos.
// A escolha é validada no servidor e propagada pra sala inteira via protocol.
// =============================================================================
import type { CharacterId } from './characters';

// Gancho pra desbloqueio por conquista (PR futuro): por enquanto tudo 'livre'.
export type SkinUnlock = 'livre' | 'conquista';

export interface SkinDef {
  /** Id da skin dentro do personagem ('oficial' é o padrão implícito). */
  id: string;
  nome: string;
  desc: string;
  unlock: SkinUnlock;
}

/** Skin padrão de todo personagem (o visual original). */
export const DEFAULT_SKIN = 'oficial';

export const DEFAULT_SKIN_DEF: SkinDef = {
  id: DEFAULT_SKIN,
  nome: 'Traje Oficial',
  desc: 'O figurino clássico de posse. Nunca foi réu (ainda).',
  unlock: 'livre',
};

// Skins alternativas por personagem. O id viaja no protocolo junto do charId.
export const CHARACTER_SKINS: Partial<Record<CharacterId, SkinDef[]>> = {
  lula: [{
    id: 'papuda',
    nome: 'Uniforme da Papuda',
    desc: 'Conjunto laranja 580 dias de uso. Lavado em Curitiba.',
    unlock: 'livre',
  }],
  bolsonaro: [{
    id: 'papuda',
    nome: 'Uniforme da Papuda',
    desc: 'Laranja inelegível, corte sob medida pra tornozeleira.',
    unlock: 'livre',
  }],
  temer: [{
    id: 'conde',
    nome: 'Conde da Madrugada',
    desc: 'Palidez constitucional e sede de emenda. Aprovado em plenário às 3h.',
    unlock: 'livre',
  }],
};

/** Todas as skins do personagem, com o Traje Oficial sempre em primeiro. */
export function skinsFor(charId: string): SkinDef[] {
  const extras = (CHARACTER_SKINS as Record<string, SkinDef[] | undefined>)[charId] ?? [];
  return [DEFAULT_SKIN_DEF, ...extras];
}

export function hasSkins(charId: string): boolean {
  return skinsFor(charId).length > 1;
}

export function skinDef(charId: string, skinId: string): SkinDef | undefined {
  return skinsFor(charId).find((s) => s.id === skinId);
}

/** Valida um skinId vindo da rede pro personagem dado. */
export function isSkinId(charId: string, skinId: unknown): skinId is string {
  return typeof skinId === 'string' && skinsFor(charId).some((s) => s.id === skinId);
}

/** Skin vinda da rede: inválida ou de outro personagem vira o Traje Oficial. */
export function sanitizeSkin(charId: string, skinId: unknown): string {
  return isSkinId(charId, skinId) ? skinId : DEFAULT_SKIN;
}
